'use es6';

import { getAnalyticsScriptSource, getAnalyticsCanonicalUrl } from 'MeetingsBase/utils/utils';
import UrlParts from 'PatternValidationJS/regex/parts/UrlParts';
var domain = UrlParts.domain,
    protocol = UrlParts.protocol;
var domainRegexStr = "^" + protocol + "(" + domain + ")";
export var getUrlDomain = function getUrlDomain(url) {
  var match = url.match(domainRegexStr);
  return match && match[1];
};

function getCookie(name) {
  var cookieValue = null;

  if (document.cookie && document.cookie !== '') {
    var cookies = document.cookie.split(';');

    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i].trim();

      if (cookie.substring(0, name.length + 1) === name + "=") {
        cookieValue = cookie.substring(name.length + 1);
        break;
      }
    }
  }

  return cookieValue;
}

export function getHubSpotUtk() {
  return getCookie('hubspotutk');
}

var __hstc;

var __hssc;

var __hsfp;

export function getHubSpotIdentityInfo() {
  return {
    __hstc: __hstc,
    __hssc: __hssc,
    __hsfp: __hsfp
  };
}

function attachEmbedSpecificCallbacks(portalId, parentPageInfo) {
  var pageId = parentPageInfo.pageId,
      folderId = parentPageInfo.folderId,
      contentType = parentPageInfo.contentType,
      contentGroupId = parentPageInfo.contentGroupId;
  var setPortalId = ['setPortalId', portalId];
  var setCookiePolicy = ['setCookiePolicy', [{
    enabled: true,
    privacyPolicy: 2,
    privacyDefault: true
  }]];
  var setPageId = ['setPageId', pageId || null];
  var setContentType = ['setContentType', contentType || null];
  var setContentMetadata = ['setContentMetadata', {
    contentPageId: pageId || null,
    contentFolderId: folderId || null,
    contentGroupId: contentGroupId || null
  }];

  window._hsq.push(setPortalId);

  window._hsq.push(setCookiePolicy);

  window._hsq.push(setPageId);

  window._hsq.push(setContentType);

  window._hsq.push(setContentMetadata);
}

export function trackHsFormViews(formGuid, portalId, parentPageInfo, embedded) {
  if (!formGuid) {
    return;
  }

  var canonicalUrl = ['setCanonicalUrl', getAnalyticsCanonicalUrl()];
  var attachFormGuid = ['trackFormView', formGuid, {
    formType: 5
  }];
  window._hsq = window._hsq || [];

  if (embedded) {
    attachEmbedSpecificCallbacks(portalId, parentPageInfo);
  }

  window._hsq.push(canonicalUrl);

  window._hsq.push(attachFormGuid);
}
export function addHsTrackingCode(portalId, embedded) {
  var scriptId = 'hs-script-loader';

  if (document.getElementById(scriptId)) {
    return;
  }

  var hsAnalyticsScript = document.createElement('script');
  hsAnalyticsScript.async = true;
  hsAnalyticsScript.id = scriptId;
  hsAnalyticsScript.src = getAnalyticsScriptSource(portalId, embedded);
  document.body.appendChild(hsAnalyticsScript);

  window._hsq.push(['addIdentityListener', function (hstc, hssc, hsfp) {
    __hstc = hstc;
    __hssc = hssc;
    __hsfp = hsfp;
  }]);
} // MeetingsLib version is more valuable in New Relic alongside
// other metrics since MeetingsPublic is rarely deployed

export function trackLibVersionInNewRelic() {
  if (window.newrelic && window.newrelic.setCustomAttribute && typeof window.newrelic.setCustomAttribute === 'function' && window.hubspot && window.hubspot.bender && window.hubspot.bender.depVersions && window.hubspot.bender.depVersions.MeetingsLib) {
    window.newrelic.setCustomAttribute('meetingsLibVersion', window.hubspot.bender.depVersions.MeetingsLib);
  }
}